export default function extractPhotoName(nameWithUrl) {
  const parts = nameWithUrl.split('/')
  const dateIndex = parts.length - 2
	const bareNameIndex = parts.length - 1
	return `${parts[dateIndex]}/${parts[bareNameIndex]}`
}